var _defs, _g, _g2;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";
import { forwardRef } from "react";

const SvgRidenowLogo = (_ref, ref) => {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 633.9 176.9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #de0707;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.7,67.6h59.9l-4.5,18.6h-33.6l-3,12.1h31.7l-4.5,18.6h-31.6l-6,24.8h-26.3l17.9-74.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.9,67.6h26.9l-17.9,74.1h-26.9l17.9-74.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.1,67.6h25.1l-17.9,74.1h-22.9l-17.8-39.4-9.5,39.4h-25.1l17.9-74.1h23.1l17.6,39.3,9.4-39.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.6,129.8h-26.9l-6.5,11.9h-26.5l45.1-74.1h33.2l9.6,74.1h-27.1l-.8-11.9ZM294.5,86.7l-13.6,24.7h15.4l-1.8-24.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M403.1,67.6h25.1l-17.9,74.1h-22.9l-17.8-39.4-9.5,39.4h-25.1l17.9-74.1h23.1l17.6,39.3,9.4-39.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M511.6,92.9l-26.8,3.1c-.5-6.7-3.7-10.1-9.7-10.1s-5.4.7-7.4,2.2-3.7,3.3-4.9,5.7c-1.3,2.3-2.2,4.8-2.8,7.4-.6,2.3-.9,4.7-1.1,7.3-.2,2.6,0,5,.6,7.3s1.8,4.1,3.5,5.6c1.7,1.4,4.2,2.1,7.5,2.1s5.8-.8,7.6-2.4c1.9-1.6,3.3-4.1,4.2-7.6h26.8c-1.7,9.5-6.2,16.9-13.4,22.2s-16.5,7.9-27.8,7.9-14.8-1.3-20.1-3.9c-5.3-2.6-9.2-6-12-10.3-2.7-4.3-4.3-9-4.9-14.3-.5-5.2-.1-10.4,1.1-15.6,1.1-4.4,2.8-8.7,5.2-12.7s5.4-7.6,9.2-10.8c3.8-3.1,8.3-5.6,13.4-7.5,5.1-1.8,10.9-2.8,17.4-2.8s12.6,1.1,17.8,3.4c5.1,2.2,9.2,5.4,12.1,9.5,2.9,4.1,4.4,8.8,4.5,14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M549.7,95.3h34.1l-4.4,18.2h-34.1l-2.5,10.2h38.5l-5.7,18.2h-63.6l17.9-74.1h62.9l-4.4,18.2h-36.5l-2.3,9.4Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.3 41.8 141.7 41.8 141.7 35.8 8.1 35.8 8.1 95.2 14.3 95.2 14.3 41.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.3 112.9 8.1 112.9 8.1 172.4 307.4 172.4 307.4 166.4 14.3 166.4 14.3 112.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "619.3 166.4 326.1 166.4 326.1 172.4 625.5 172.4 625.5 112.9 619.3 112.9 619.3 166.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "495.7 35.8 495.7 41.8 619.3 41.8 619.3 95.2 625.5 95.2 625.5 35.8 495.7 35.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.8,19.6h-15.6l-16.3,21.3-2-4.5c-1.7-4.1-8.8-5.5-8.8-5.5,18.3-3.7,27.8-13.7,27.8-13.7,4.5-5-.7-6.5-.7-6.5-20.8-7.4-61.1-.6-61.1-.6-11.4,1.6-20.1,6.3-20.1,6.3,31.1-5.9,59.5-.3,59.5-.3,2.7,1-.1,3-.1,3-7.3,5.8-17.8,8.9-21,9.7l9.3-12.4s-21.4-2.7-51.4,2.3c0,0-3.6,1.8-5,3.6,0,0,23.5-1.7,32.6.1l-22.3,29.2h19.6c0,0,16.8-22.3,16.8-22.3,2.1,1.3,4.5,6.6,6,10.2.9,2.1,5.8,16.8,5.8,16.8l21.8.2-5-11.2h10.4l19.6-25.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.5,32.2c-3.3,4.3-6.3,6.6-12,6.6h-3.9l10.2-13.3h3.8c5.6,0,5.2,2.3,1.9,6.7M284.6,32.4c8-10.4,1.6-12.9-10-12.9h-22.9l-19.6,25.6h22.2c11.6,0,22.8-3,30.3-12.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "296 39 298.7 35.5 317.8 35.5 322.5 29.3 303.4 29.3 306.2 25.7 326.1 25.7 330.8 19.6 295.6 19.6 276 45.1 311.6 45.1 316.4 39 296 39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "369.6 14.6 356.7 32 357.1 14.6 338.1 14.6 311.8 50.2 326.8 50.2 339 33.8 338.4 50.2 357.7 50.2 384 14.6 369.6 14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401,32.4c-2.1,2.7-5.5,7.1-11.6,7.1s-3-4.3-1-7.1c1.8-2.4,5.7-7.1,11.5-7.1s2.9,4.7,1.2,7.1M417.3,32.4c6.3-8.6,1.3-13.2-12.9-13.2s-26,4.7-32.3,13.2c-6.4,8.7-1.4,13.2,12.8,13.2s26-4.5,32.5-13.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "474.4 19.6 460.2 33.5 464.8 19.6 447.5 19.6 433 33.8 438.2 19.6 423.6 19.6 414.2 45.1 431.3 45.1 450.1 28.4 450.2 28.4 444.7 45.1 461.5 45.1 490.1 19.6 474.4 19.6"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgRidenowLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ridenow-logo.c04b23616e89c0e967283f614193fcaa.svg";